import { IncomingMessage, ServerResponse } from 'http'

type SameSite = 'Strict' | 'Lax' | 'None'

export type CookieOptions = {
  path?: string
  maxAge?: number
  httpOnly?: boolean
  secure?: boolean
  sameSite?: SameSite
  domain?: string
}

export const getCookieFromRequest = (req: IncomingMessage, cookieName: string): string | null => {
  const raw = req.headers?.cookie || ''
  if (!raw) return null
  const cookies = Object.fromEntries(raw.split('; ').map((c) => c.split('=')))
  return cookies[cookieName] || null
}

export const setCookieOnResponse = (
  res: ServerResponse,
  cookieName: string,
  value: string,
  options: CookieOptions = {}
): void => {
  const {
    path = '/',
    maxAge = 31536000, // 1 year
    httpOnly = false,
    secure = false,
    sameSite = 'Lax',
    domain,
  } = options

  const parts: string[] = []
  parts.push(`${cookieName}=${value}`)
  if (path) parts.push(`Path=${path}`)
  if (typeof maxAge === 'number') parts.push(`Max-Age=${Math.floor(maxAge)}`)
  if (domain) parts.push(`Domain=${domain}`)
  if (secure) parts.push('Secure')
  if (httpOnly) parts.push('HttpOnly')
  if (sameSite) parts.push(`SameSite=${sameSite}`)

  const serialized = parts.join('; ')

  const prev = res.getHeader('Set-Cookie')
  if (!prev) {
    res.setHeader('Set-Cookie', serialized)
  } else if (Array.isArray(prev)) {
    res.setHeader('Set-Cookie', [...prev, serialized])
  } else {
    res.setHeader('Set-Cookie', [prev.toString(), serialized])
  }
}
